"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.jsonValue = void 0;

var string_1 = require("./string");

var JsonConstraintsBuilder_1 = require("./_internals/helpers/JsonConstraintsBuilder");

var anything_1 = require("./anything");

function jsonValue() {
  var constraints = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, anything_1.anything)((0, JsonConstraintsBuilder_1.jsonConstraintsBuilder)((0, string_1.string)(), constraints));
}

exports.jsonValue = jsonValue;